<app-dashboard-header></app-dashboard-header>

<section class="bg-white">
    <div class="container">
        <h2 class="pt-5">الصلاحيات</h2>
        <table class="table table-hover mt-5">
            <thead class="thead-dark">
                <tr>
                    <th>اسم المستخدم</th>
                    <th>الصلاحيات</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users;let i= index">
                    <td>{{user.userName}}</td>
                    <td *ngFor="let role of roles" >
                        <input type="checkbox" *ngIf="role.type!='superAdmin'" [checked]="user.roles.includes(role._id)" (change)="onChange(user._id, role._id,$event.target.checked)"/>&nbsp; &nbsp;
                        <b *ngIf="role.type!='superAdmin'">{{role.type}}</b>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</section>

<app-dashboard-footer></app-dashboard-footer>